import { FieldError } from "react-hook-form"

type ErrorObject = Partial<FieldError> | RecordOfErrors

interface RecordOfErrors {
  [k: string]: ErrorObject
}

export function extractErrorMessage(errorObject?: ErrorObject): string | undefined {
  if (typeof errorObject != "object") {
    return undefined
  }

  if (typeof errorObject.message === "string") {
    return errorObject.message
  }

  // this line is used for type assertion on errorObject
  if (!isRecordOfErrors(errorObject)) return undefined

  for (const key in errorObject as RecordOfErrors) {
    const potentialErrorMessage = extractErrorMessage(errorObject[key])

    if (typeof potentialErrorMessage === "string") {
      return potentialErrorMessage
    }
  }
}

const isRecordOfErrors = (errorObject: ErrorObject): errorObject is RecordOfErrors =>
  typeof errorObject === "object"
